// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._1gzjidpf >span{padding-left:0}\n._1plv1j28 >span{background-color:transparent}\n._1r3373ad >span{cursor:default}", ""]);
// Exports
module.exports = exports;
